/** Approval / rejection comment form used in the request detail view. */
import { useState } from "react";

type Props = {
  action: "approve" | "reject";
  onConfirm: (comments?: string) => void;
  onCancel: () => void;
  loading?: boolean;
};

export function TrainingEnrollmentForm({ action, onConfirm, onCancel, loading }: Props) {
  const [comments, setComments] = useState("");
  const isReject = action === "reject";

  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-600">
        {isReject
          ? "Provide a reason for rejecting this training request."
          : "Optionally add a note for the requestor."}
      </p>
      <textarea
        className="input min-h-20 resize-y"
        value={comments}
        onChange={(e) => setComments(e.target.value)}
        placeholder={isReject ? "Reason for rejection…" : "Optional comments…"}
        required={isReject}
        disabled={loading}
      />
      <div className="flex justify-end gap-2">
        <button
          type="button"
          onClick={onCancel}
          disabled={loading}
          className="rounded-xl border px-4 py-2 text-sm font-semibold text-slate-600 hover:bg-slate-50 disabled:opacity-50"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={() => onConfirm(comments.trim() || undefined)}
          disabled={loading || (isReject && !comments.trim())}
          className={`rounded-xl px-4 py-2 text-sm font-semibold text-white disabled:opacity-50 ${
            isReject ? "bg-red-600 hover:bg-red-700" : "bg-emerald-600 hover:bg-emerald-700"
          }`}
        >
          {loading
            ? isReject ? "Rejecting…" : "Approving…"
            : isReject ? "Reject Request" : "Approve Request"}
        </button>
      </div>
    </div>
  );
}
